<template>
    <el-dialog v-model="state.visible" :width="isMobile ? '100vw' : '380px'" modal-class="checkout-login-dialog"
        :before-close="handleClickClose" destroy-on-close>
        <div class="mb-5">
            <el-button type="primary" style="width: 100%; padding: 2rem 0; font-size: 1.5rem;"
                @click="handleLoginRedirect()">
                註冊、登入會員
            </el-button>
            <div class="text-center text-xl lg:text-lg my-1">
                (推薦)登入會員再購物，方便您管理訂單
            </div>
        </div>
        <div>
            <el-button style="width: 100%; padding: 1.5rem 0; font-size: 1.2rem;" @click="handleSkipLogin()">
                非會員購物
            </el-button>
        </div>
    </el-dialog>
</template>
  
<script setup>
import { computed, reactive, watch } from 'vue'
import { useStore } from 'vuex'
import { useI18n } from "vue-i18n"
import {
    breakpoint,
} from "../../utils"

const props = defineProps({})

const { t, n, locale } = useI18n()
const store = useStore()

const isMobile = computed(() => breakpoint.value.xs || breakpoint.value.sm)
const loginUserId = computed(() => store.getters['lite/userData']?.id);

const state = reactive({
    visible: false,
});

const handleClickClose = () => {
    store.commit('lite/setCheckoutLoginDialogVisible', false);
};

const handleLoginRedirect = () => {
    window.localStorage.setItem('liteAutoOpenCheckoutDialogLogonCallback', +new Date());
    window.location.href = `/login`;
}

const handleSkipLogin = () => {
    store.commit('lite/setCheckoutLoginDialogVisible', false);
    store.dispatch('lite/openCheckoutDialog', { skipLogin: true });
}

watch(
    () => store.getters["lite/checkoutLoginDialogVisible"],
    (newVisible) => {
        state.visible = newVisible;
    },
    { deep: true, immediate: true }
);

</script>
  